module.exports = __webpack_public_path__ + "img/del_btn.1c1d3161.svg";